import {
    partitionSupportedImageFiles,
    unsupportedImageUploadMessage,
} from "../common/utils/image.util";
import { EventEmitter } from "../EventEmitter";

export function takeSupportedImageFiles(
    files: FileList | readonly File[] | null,
): File[] {
    if (!files) {
        return [];
    }

    const { supported, rejected } = partitionSupportedImageFiles(files);
    if (rejected.length > 0) {
        EventEmitter.emit({
            name: "showToastMessage",
            params: {
                type: "error",
                message: unsupportedImageUploadMessage(rejected),
            },
        });
    }

    return supported;
}
